import React, { Component } from 'react';
import axios from 'axios';
import { Col } from 'react-bootstrap';
import { uAPI } from '../config/Config';
import img from './images/Kedoya-Contact-Us.jpg';
import './assets/dashboard-modern.css';

class Dashboard extends Component {
  state = { summary: { total: 0, success: 0, failed: 0, pending: 0 }, loading: true };

  componentDidMount() {
    this.loadSummary();
  }

  loadSummary = async () => {
    try {
      const response = await axios.get(uAPI + '/api/v1/email-logs/summary');
      this.setState({ summary: response.data.results || this.state.summary, loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  render() {
    const s = this.state.summary;
    return (
      <Col md={12} className="modern-dashboard">
        <section className="dash-hero">
          <div><span>BOOKING MCU</span><h1>Bio Medika</h1><p>Kelola pendaftaran, kuota, reminder, QR peserta, dan monitoring email dalam satu dashboard.</p></div>
          <img src={img} alt="Bio Medika" />
        </section>
        <section className="dash-grid">
          <div className="dash-card"><small>TOTAL EMAIL</small><strong>{s.total}</strong><span>Semua proses import</span></div>
          <div className="dash-card good"><small>EMAIL TERKIRIM</small><strong>{s.success}</strong><span>Berhasil dikirim</span></div>
          <div className="dash-card warn"><small>DALAM ANTREAN</small><strong>{Number(s.pending || 0) + Number(s.processing || 0) + Number(s.retry || 0)}</strong><span>Menunggu proses</span></div>
          <div className="dash-card bad"><small>EMAIL GAGAL</small><strong>{s.failed}</strong><span>Bisa di-retry dari Email Log</span></div>
        </section>
        <section className="dash-note"><div><b>Monitoring email sekarang aktif</b><p>Setiap email hasil import dicatat. Jika satu alamat gagal, peserta lainnya tetap diproses.</p></div><a href="/admin/email-log">Buka Email Log →</a></section>
      </Col>
    );
  }
}
export default Dashboard;
